import * as fromDatatype from '../datatype-library/index';

export interface app_perm_dfn_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  parent_id: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.GuidDataFieldInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  perm_type: fromDatatype.VarcharDatatypeInterface;
  perm_code: fromDatatype.VarcharDatatypeInterface;
  perm_name: fromDatatype.TextDatatypeInterface;
  perm_description: fromDatatype.TextDatatypeInterface;
  operation_options: fromDatatype.TextDatatypeInterface;
  target_options: any;
  operation_default: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_perm_dfn_RowClass implements app_perm_dfn_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  parent_id: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.GuidDataFieldInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  perm_type: fromDatatype.VarcharDatatypeInterface;
  perm_code: fromDatatype.VarcharDatatypeInterface;
  perm_name: fromDatatype.TextDatatypeInterface;
  perm_description: fromDatatype.TextDatatypeInterface;
  operation_options: fromDatatype.TextDatatypeInterface;
  target_options: any;
  operation_default: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
